export const READ_DOMAIN_SETTING = 'READ_DOMAIN_SETTING';
export const WRITE_DOMAIN_SETTING = 'WRITE_DOMAIN_SETTING';
export const READ_SYSTEM_SETTING = 'READ_SYSTEM_SETTING';
export const WRITE_SYSTEM_SETTING = 'WRITE_SYSTEM_SETTING';
export const READ_PROFIT_WHITELIST = 'READ_PROFIT_WHITELIST';
export const WRITE_PROFIT_WHITELIST = 'WRITE_PROFIT_WHITELIST';
export const CREATE_CRYPTO_LIB_MANAGER = 'CREATE_CRYPTO_LIB_MANAGER';
export const READ_CRYPTO_LIB_MANAGER = 'READ_CRYPTO_LIB_MANAGER';
export const UPDATE_CRYPTO_LIB_MANAGER = 'UPDATE_CRYPTO_LIB_MANAGER';
export const READ_USER_LOG = 'READ_USER_LOG';